import { fuzzyFilter } from 'fuzzbunny'
import { sortBy } from 'lodash'
import { useEffect, useMemo, useState } from 'react'
import { ComboboxOption, isOptionGroupGuard, isOptionGuard } from './types'

export const useFilteredOptions = ({
  options: _options,
  defaultValue,
  search,
}) => {
  // copy options so that we are not modifying the prop that got passed in
  const [options, setOptions] = useState(() => {
    const defaultOpt = defaultValue ? [{ id: null, value: defaultValue }] : []
    return [...defaultOpt, ..._options]
  })

  useEffect(() => {
    const defaultOpt = defaultValue ? [{ id: null, value: defaultValue }] : []
    setOptions([...defaultOpt, ..._options])
  }, [_options])

  const flattenedOptions = useMemo(() => {
    const hasHeaders = options.some(
      (opt) => isOptionGroupGuard(opt) && opt.name,
    )
    if (!hasHeaders) {
      return options
    }

    return options
      .map((opt) => {
        if (isOptionGroupGuard(opt)) {
          return opt.options
        }
        return opt
      })
      .flat()
  }, [options])

  const filtered = useMemo(() => {
    if (!search) {
      return options
    }

    const results = fuzzyFilter(flattenedOptions as ComboboxOption[], search, {
      fields: ['value'],
    })
    return sortBy(results, ['scored']).map((match) => {
      if (isOptionGuard(match.item)) {
        return {
          id: match.item.id,
          value: match.item.value,
          highlights: match.highlights['value'],
        }
      }
    })
  }, [flattenedOptions, options, search])

  return filtered
}
